import * as React from 'react';
import { connect } from 'react-redux';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import VendorList from "./Vendor";
import AgencyVendorContract from "./AgencyVendorContract";

export interface VendorTabContainerProps {
  setSelectedTab?: (key: string) => void;
}

class VendorTabContainer extends React.Component<
    VendorTabContainerProps,
  any
> {
  public render() {
    return (
      <div>
        <Tabs
          defaultActiveKey="Vendor List"
          id="vendor-tabs"
        >
          <Tab eventKey="Vendor List" title="Vendors">
            <VendorList />
          </Tab>
          <Tab eventKey="Connect Vendor to Agency" title="Connect Vendor to Agency">
            <AgencyVendorContract />
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export function mapStateToProps() {
  return {};
}

const mapDispatchToProps = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorTabContainer);
